<template>
  <header
    class="fixed top-0 left-0 flex items-center justify-between flex-shrink-0 w-full py-4 bg-white border-b navigation z-header viewport-gutter color-white border-au_gray-150"
  >
    <div class="container flex items-center justify-between w-full">
      <div>
        <a :href="logoLink" class="block logo" />
      </div>
      <div>
        <router-link
          class="focus:outline-none"
          :class="currentLocale === 'nl' && 'font-bold'"
          :to="{ ... $route, params: { ...$route.params, locale: 'nl'}}"
        >
          NL
        </router-link>

        <router-link
          class="focus:outline-none"
          :class="currentLocale === 'fr' && 'font-bold'"
          :to="{ ... $route, params: { ...$route.params, locale: 'fr'}}"
        >
          FR
        </router-link>

        <router-link
          class="focus:outline-none"
          :class="currentLocale === 'en' && 'font-bold'"
          :to="{ ... $route, params: { ...$route.params, locale: undefined}}"
        >
          EN
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import Header from '~brand-components/base/shared/header'

export default Header.extend({
  computed: {
    logoLink() {
      if (this.href) {
        return this.href
      }

      if (this.currentLocale === 'fr') {
        return 'https://www.brusselsairlines.com/be/fr/homepage'
      }

      if (this.currentLocale === 'nl') {
        return 'https://www.brusselsairlines.com/be/nl/homepage'
      }

      return 'https://www.brusselsairlines.com/be/en/homepage'
    },
  },
})
</script>

<style lang="scss" scoped>
.navigation {
  height: 60px;
}

.pdf-include {
  background: url("../../../images/lufthansa/hero/white_pixel.jpg");
}

.logo {
  width: 100px;
  height: 36px;
  background-size: 100px auto;
  background: url("../../../images/brussels/logos/brussels-latest.svg");
  background-position: left center;
  background-repeat: no-repeat;

  @screen md {
    width: 156px;
    height: 36px;
    background-size: 156px auto;
  }
}

.mobileNavButton {
  .lines{
    width: 27px;
    height: 14px;
    span {
      top: 0;
      height: 2px;
      &:nth-child(2) {
        top: 6px;
      }
      &:nth-child(3) {
        top: 12px;
      }
    }
  }
  &.active {
    .lines{
      span {
        top: 6px;
        &:first-child {
          @apply transform rotate-135;
          -ms-transform: rotate(135deg);
        }
        &:last-child {
          @apply transform -rotate-135;
          -ms-transform: rotate(-135deg);
        }
        &:nth-child(2) {
          opacity: 0;
        }
      }
    }
  }
}

.mobileNavigation {
  z-index: 49;
  right: 0;
  height: 100%;
}

.langSwitch{
  &:hover{
    .dropdown{
      @apply block;
    }
  }
}

@media screen and (min-width: 768px) {
  .navigation {
    height: 100px;
  }

  .mobileNavButton {
    .lines{
      width: 27px;
      height: 19px;
      span {
        &:nth-child(2) {
          top: 8px;
        }
        &:nth-child(3) {
          top: 17px;
        }
      }
    }
    &.active {
      .lines{
        span {
          top: 9px;
        }
      }
    }
  }
}

@media screen and (min-width: 1280px) {
  .mobileNavigation{
    top: 90px;
    width: 100%;
    height: auto;
    @apply bg-gray-250;
  }
}
</style>
